import React, { useEffect, useState } from "react";
import Card from "../../../components/Card";
import { Container, Row, Col, Tab, Pagination } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import loader from "../../../assets/images/page-img/page-load-loader.gif";
import useAuth from "../../../utils/useAuth";
import InfiniteScroll from "react-infinite-scroll-component";
import { getToken } from "../../../utils/auth";
import { useTranslation } from "react-i18next";

const PhotoTab = (userUid) => {
  useAuth();
  // console.log("uid", userUid.userUid);
  const [socialcard, setSocialcard] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const handleImage = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/photos/${userUid.userUid}?page=${page}&limit=5`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSocialcard((prevPosts) => [
        ...prevPosts,
        ...response.data.data.photos,
      ]);
      setHasMore(response.data.data.totalPhotos > socialcard.length);
    } catch (error) {
      console.error("Failed fetching Images", error);
    }
  };

  useEffect(() => {
    handleImage();
  }, [page]); // Fetch data whenever page changes

  const loadMore = () => {
    setPage(page + 1);
  };
    const { t, i18n } = useTranslation();

  return (
    <>
            <Col lg="12">
                    <Card>
                      <InfiniteScroll
                        style={{ overflowX: "hidden", overflowY: "auto" }}
                        dataLength={socialcard.length}
                        next={loadMore}
                        hasMore={hasMore}
                        loader={
                          <img
                            src={loader}
                            alt="loader"
                            style={{ height: "100px" }}
                          />
                        }
                        endMessage={
                          <p className="text-center">{t("noMorePhotos")}</p>
                        }
                      >
                        <div style={{ display:"flex", flexWrap:"wrap"}}>
                          {socialcard.map((item, index) => (
                            <Col sm="4" key={index}>
                              <Card>
                                <Card.Body>
                                  <div className="event-images position-relative">
                                    <Link>
                                      <img
                                        loading="lazy"
                                        src={item}
                                        className="img-fluid"
                                        alt="Image"
                                      />
                                    </Link>
                                  </div>
                                </Card.Body>
                              </Card>
                            </Col>
                          ))}
                        </div>
                      </InfiniteScroll>
                    </Card>
            </Col>
    </>
  );
};

export default PhotoTab;
